<div
  *ngIf="(dataViewFacade?.importedDatasetCount$ | async) > 0 || (adminManagedScheduleIntervalsEnabled$ | async) && ((minimumScheduleInterval$ | async) !== 'every_15_minutes')"
  class="schedule-editor-container-banner"
>
  <div *ngIf="(dataViewFacade?.importedDatasetCount$ | async) > 0" data-test="dataset-info-banner">
    <capra-icon icon="icon-info-outline"></capra-icon>
    This Report uses Datasets that refresh independently. When this <br />
    <span class="indent-row">Schedule runs, new Dataset data will be reflected automatically.</span>
  </div>

  <div
    *ngIf="(adminManagedScheduleIntervalsEnabled$ | async) && ((minimumScheduleInterval$ | async) !== 'every_15_minutes')"
    data-test="schedules-threshold-info-banner"
  >
    <br *ngIf="(dataViewFacade?.importedDatasetCount$ | async) > 0"/>
    <span class="banner-note">Note:</span> Your workspace Admin has defined that the minimum interval for schedules will be
    <b class="text-capitalize">{{ minimumScheduleInterval$ | async }}</b>.
  </div>
</div>

<div class="schedules-container">
  <mode-loader
    *ngIf="
      scheduleEditContainerInputs.reportParameterOptionsLoading &&
      scheduleEditContainerInputs.reportParameterOptionsComplete === false
    "
    type="tertiary"
    data-test="loader"
  ></mode-loader>

  <div
    class="schedules-scroll scroll-lg no-margin with-padding"
    *ngIf="scheduleEditContainerInputs.showScheduleEditForm"
    data-test="edit-form"
    (scroll)="onScroll($event)"
  >
    <!-- //// Schedule section -->
    <mode-cadence-config
      [schedule]="scheduleModalFacade.activeSchedule.cleanSchedule"
      (dayOfMonthChanged)="dayOfMonthChanged.emit($event)"
      (dayOfWeekChanged)="dayOfWeekChanged.emit($event)"
      (frequencyChange)="
        scheduleModalFacade.onFrequencyChange({
          rawSchedule: scheduleEditContainerInputs.schedule,
          newFrequency: $event
        })
      "
      (startTimeChanged)="startTimeChanged.emit($event)"
      (timeChanged)="timeChanged.emit($event)"
    ></mode-cadence-config>
    <!-- //// End Schedule section -->
    <!-- //// Subscription section -->
    <div class="section" *ngIf="scheduleEditContainerInputs.isDataset === false" data-id="bottom-section">
      <hr class="schedules-break" />

      <mode-delivery
        *ngIf="(thoughtSpotIntegrated$ | async) === false"
        [deliveryType]="scheduleEditContainerInputs.notifyType"
        [slackDeliveryOptionEnabled]="scheduleEditContainerInputs.slackDeliveryOptionEnabled"
        (deliveryTypeChanged)="deliveryTypeChanged.emit($event)"
        data-test="delivery"
      ></mode-delivery>

      <hr
        *ngIf="scheduleEditContainerInputs.notifyType === 'email' || scheduleEditContainerInputs.notifyType === 'slack'"
        class="sub-section-line-break"
        data-test="schedule-sub-section"
      />

      <mode-email-settings
        *ngIf="scheduleEditContainerInputs.notifyType === 'email'"
        [disableEmailAttachments]="scheduleOwnerFacade.emailAttachmentsEnabled === false"
        [selections]="{
              csv: scheduleEditContainerInputs.subscription.csv_attachments_enabled,
              pdf: scheduleEditContainerInputs.subscription.pdf_attachments_enabled,
              previewImages: scheduleEditContainerInputs.subscription.data_previews_enabled,
              tablesOfRawData: scheduleEditContainerInputs.subscription.data_tables_enabled,
              urlLinks: scheduleEditContainerInputs.subscription.report_links_enabled,
            }"
        [testEmail]="scheduleEditContainerInputs.email"
        (selectionsChanged)="
          scheduleSubscriptionFacade.settingsChanged(
            scheduleEditContainerInputs.subscription,
            scheduleModalFacade,
            $event
          )
        "
        (sendTestEmail)="testEmail.emit()"
      >
        <mode-email-settings-header></mode-email-settings-header>
      </mode-email-settings>

      <div
        class="schedule-form-item clearfix"
        *ngIf="scheduleEditContainerInputs.notifyType === 'slack'"
        data-test="slack-container"
      >
        <mode-slack-channel-selector
          [slackChannelDetails]="{
            slackAppUrl: scheduleSlackFacade.slackAppUrl,
            slackAppTeamName: scheduleSlackFacade.slackAppTeamName,
            slackChannels: scheduleSlackFacade.slackChannels
          }"
          [selectedSlackChannel]="scheduleEditContainerInputs.schedule['slackChannel']"
          (setSlackChannel)="scheduleModalFacade.setSlackChannel($event)"
        ></mode-slack-channel-selector>
        <a
          class="modal-info"
          target="_blank"
          [attr.href]="helpDocs.links['https://mode.com/help/articles/report-scheduling-and-sharing/#slack']"
          >Learn more about sharing Reports in Slack</a
        >
      </div>
    </div>
    <div class="section" *ngIf="scheduleEditContainerInputs.paramsExist === true" data-id="bottom-section">
      <hr class="schedules-break" />
      <div data-test="parameter-container">
        <mode-parameters
          [defaultOptions]="scheduleEditContainerInputs.param.defaultOptions"
          [params]="scheduleEditContainerInputs.param.options"
          [scheduleParams]="scheduleEditContainerInputs.param.selectedParams"
          (paramChanged)="updateParam.emit($event)"
          (multiSelectParameterChanged)="updateMultiSelectAngular.emit($event)"
        ></mode-parameters>
      </div>
    </div>
  </div>
</div>
